import React from 'react'
import Link from 'gatsby-link'
import { Button } from 'antd'

const Aside = ( props ) => {

  const data = props.data;
  const title = data.title;

  const asideToggle = () => {
    props.onToggle();
  }


  const makeLink = (link) => {
    return (
      <li key={ link.url }>
        <Link to={ link.url } activeClassName="active" exact>{ link.title }</Link>
      </li>
    );
  }

  const buildSectionLinks = () => {
    return (
      <div>
        { data.data.map( section => {
          return (
            <div key={ section.title } className="links">
              <h3>{ section.title }</h3>
              <ul>
                { section.data.map( link => makeLink(link) ) }
              </ul>
            </div>
          )
        } ) }
      </div>
    );
  }



  const buildNormalLinks = () => {
    return (
      <div className="links">
        <ul>
          { data.data.map( link => makeLink(link) ) }
        </ul>
      </div>
    )
  }


  const asideWrapper = (
    <aside className="open">
      <div className="hide--sidebar" onClick={ asideToggle }>Hide Sidebar</div>
      <div className="post--title">
        <h3>{ title }</h3>
      </div>
      { data.type === 'normal' ? buildNormalLinks() : buildSectionLinks() }
    </aside>
  );


  const asideHiddenWrapper = (
    <aside className="closed" onClick={ asideToggle }>
    </aside>
  );


  if ( props.open ) {
    return asideWrapper;
  } else {
    return asideHiddenWrapper;
  }


}

export default Aside



// WEBPACK FOOTER //
// ./src/global/components/Aside.js